
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { isValidPhoneNumber, CountryCode } from 'libphonenumber-js';
import { customArray as CountryList } from 'country-codes-list';
import { combineLatest, Subject } from 'rxjs';
import { distinctUntilChanged, map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialogV2.component.html',
  styleUrls: ['./contact-dialog.component.scss'],
  providers: [DialogService],
})
export class ContactDialogComponent implements OnInit, OnDestroy {
  newContactForm!: FormGroup;
  countryCodes = CountryList({ value: '{countryCode}', label: '{countryNameEn}', callCode: '+{countryCallingCode}' });
  phoneCountry = new FormControl<any>(null, { nonNullable: true });
  destroy$ = new Subject<void>();

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {
    if (!(this.config.data instanceof FormGroup)) {
      this.ref.close();
      return;
    }

    this.newContactForm = this.config.data;

    const defaultCountry = this.countryCodes.find((c: any) => c.value === 'DK');
    this.phoneCountry.setValue(defaultCountry);

    this.setupPhoneValidation();
    this.setupSendLabelState();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setupPhoneValidation(): void {
    const phoneControl = this.newContactForm.get('phone');

    if (!phoneControl) {
      return;
    }

    phoneControl.addValidators(this.phoneNumberValidator());
    phoneControl.updateValueAndValidity({ emitEvent: false });

    this.phoneCountry.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        phoneControl.updateValueAndValidity();
      });
  }

  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phone = control.value;
      const country = this.phoneCountry.value?.value as CountryCode | undefined;

      if (!phone) {
        return null;
      }

      if (!country) {
        return { invalidPhoneCountry: true };
      }

      return isValidPhoneNumber(phone, country)
        ? null
        : { invalidPhoneNumber: true };
    };
  }

  setupSendLabelState(): void {
    const emailControl = this.newContactForm.get('email');
    const sendLabelControl = this.newContactForm.get('sendLabel');

    if (!emailControl || !sendLabelControl) {
      return;
    }

    combineLatest([emailControl.valueChanges.pipe(startWith(emailControl.value)), emailControl.statusChanges.pipe(startWith(emailControl.status))])
      .pipe(
        map(([email, status]) => Boolean(email) && status === 'VALID'),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((canSendLabel) => {
        if (canSendLabel) {
          sendLabelControl.enable({ emitEvent: false });
        } else {
          sendLabelControl.setValue(false, { emitEvent: false });
          sendLabelControl.disable({ emitEvent: false });
        }
      });
  }

  addContactPerson(): void {
    if (this.newContactForm.invalid) {
      this.newContactForm.markAllAsTouched();
      return;
    }
    this.ref.close(this.newContactForm);
  }

  closeDialog(): void {
    this.ref.close();
  }
}

// @Component({
//   selector: 'app-contact-dialog',
//   templateUrl: './contact-dialog.component.html',
//   styleUrls: ['./contact-dialog.component.scss'],
//   providers: [DialogService]
// })
// export class ContactDialogComponent implements OnInit {
//   newContactForm: FormGroup;

//   countryCodes = CountryList({ value: '{countryCode}', label: '{countryNameEn}', callCode: '+{countryCallingCode}' });
//   selectedPhoneCountry: any;

//   constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

//   ngOnInit(): void {
//     if (!this.config.data) {
//       this.ref.close();
//     }
//     this.newContactForm = this.config.data;
//     this.selectedPhoneCountry = this.countryCodes.find((c: any) => c.value == 'DK');

//     this.newContactForm.valueChanges.subscribe((value: any) => {
//       if (value.phone) {
//         if (isValidPhoneNumber(value.phone, this.selectedPhoneCountry.value)) {
//           this.newContactForm.controls.phone.setErrors(null);
//         } else {
//           this.newContactForm.controls.phone.setErrors({ 'invalid': true });
//         }
//       }
//     });
//     this.newContactForm.controls.email.statusChanges.subscribe((value: any) => {
//       if (value === 'INVALID') {
//         this.newContactForm.controls.sendLabel.disable();
//         this.newContactForm.controls.sendLabel.setValue(false);
//       } else {
//         if (this.newContactForm.controls.email.value) {
//           this.newContactForm.controls.sendLabel.enable();
//         }
//         else {
//           this.newContactForm.controls.sendLabel.disable();
//           this.newContactForm.controls.sendLabel.setValue(false);
//         }
//       }
//     });

//     if (this.newContactForm.controls.email.value && this.newContactForm.controls.email.valid) {
//       this.newContactForm.controls.sendLabel.enable();
//     }
//   }


//   onPhoneCountryChange(event: any) {
//     if (this.newContactForm.controls.phone.value) {
//       const isValidPhone = isValidPhoneNumber(this.newContactForm.controls.phone.value, this.selectedPhoneCountry.value);
//       if (!isValidPhone) {
//         this.newContactForm.controls.phone.setErrors({ 'invalid': true });
//       }
//       else {
//         this.newContactForm.controls.phone.setErrors(null);
//       }

//     }
//   }

//   addContactPerson() {
//     this.ref.close(this.newContactForm);
//   }


//   closeDialog() {
//     this.ref.close();
//   }

// }


